<%= form_with(model: formation, class: "contents") do |form| %>
  <% if formation.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(formation.errors.count, "error") %> prohibited this formation from being saved:</h2>

      <ul class="list-disc ml-6">
        <% formation.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :person_id %>
    <%= form.text_field :person_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": formation.errors[:person_id].none?, "border-red-400 focus:outline-red-600": formation.errors[:person_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :solo_id %>
    <%= form.text_field :solo_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": formation.errors[:solo_id].none?, "border-red-400 focus:outline-red-600": formation.errors[:solo_id].any?}] %>
  </div>

  <div class="my-5 flex items-center gap-2">
    <%= form.label :on_floor %>
    <%= form.checkbox :on_floor, class: ["block shadow-sm rounded-md border order-first h-5 w-5", {"border-gray-400 focus:outline-blue-600": formation.errors[:on_floor].none?, "border-red-400 focus:outline-red-600": formation.errors[:on_floor].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
